var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeaderLayout',[_c('div',{staticClass:"main-page-content"},[_c('TiktokData')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }